import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { useCalculatorContext } from '../../../contexts';
import { parseKeyToDataTest } from '../../../utils';
import { Control } from '../Control';
import { ObjectDecorator } from '../ObjectDecorator';
import styles from "./styles.module.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function isRowConfig(row) {
  return Boolean(_typeof(row) === 'object' && row && 'controls' in row);
}
export function ObjectControlUi(_ref) {
  var _ref2;
  var controls = _ref.controls,
    ui = _ref.ui,
    watchedValues = _ref.watchedValues,
    relateFn = _ref.relateFn,
    visibleProp = _ref.visible,
    decoratorProps = _ref.decoratorProps;
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType;
  var isMobile = layoutType === 'mobile';
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedVisible = _useMemo.visible;
  var dataTestAttribute = parseKeyToDataTest('row');
  var visible = (_ref2 = relatedVisible !== null && relatedVisible !== void 0 ? relatedVisible : visibleProp) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [decoratorProps && decoratorProps.label && /*#__PURE__*/_jsx(ObjectDecorator, _objectSpread({}, decoratorProps)), ui.map(function (uiRow) {
      if (typeof uiRow === 'string') {
        return /*#__PURE__*/_jsx(Control, {
          formControl: controls[uiRow]
        }, uiRow);
      }
      if (Array.isArray(uiRow)) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.row,
          "data-test-id": dataTestAttribute,
          "data-mobile": isMobile || undefined,
          children: uiRow.map(function (rowItem) {
            return /*#__PURE__*/_jsx(Control, {
              formControl: controls[rowItem]
            }, rowItem);
          })
        }, uiRow.join(' '));
      }
      if (isRowConfig(uiRow)) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.rowConfig,
          style: {
            gridTemplateColumns: uiRow.template || '1fr 84px'
          },
          children: uiRow.controls.map(function (rowItem) {
            return /*#__PURE__*/_jsx(Control, {
              formControl: controls[rowItem]
            }, rowItem);
          })
        }, uiRow.controls.join(' '));
      }
      return /*#__PURE__*/_jsx(_Fragment, {
        children: uiRow
      });
    })]
  });
}